import RadioImage from './RadioImage';
import Group from './Group';

RadioImage.Group = Group;

export default RadioImage;